// Cross-browser auth state: persisted on the modal's own origin via localStorage,
// which behaves identically in Chrome, Edge, and Firefox. The browser extension's
// chrome.storage.secure is a separate, extension-side concern.

const KEY = "nl-stealth-session";
const TTL_MS = 30 * 60 * 1000; // 30 minutes

export interface Session {
  clientId: string;
  ts: number;
}

export function saveSession(clientId: string): void {
  try {
    localStorage.setItem(KEY, JSON.stringify({ clientId, ts: Date.now() }));
  } catch {
    // Storage unavailable (private mode / blocked) — degrade to no persistence.
  }
}

export function loadSession(): Session | null {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const session = JSON.parse(raw) as Session;
    if (Date.now() - session.ts > TTL_MS) {
      clearSession();
      return null;
    }
    return session;
  } catch {
    return null;
  }
}

export function clearSession(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {
    // ignore
  }
}
